import { ITaskListItem } from "@/src/api/tasksPageRequests";
import { ITasksTableRow } from "@/src/types/tasksTable";
import { parseTaskApplicantId, parseTaskApplicantInfo, resolveTaskApiId } from "./parseTaskApplicantInfo";

export interface ResolvedTaskApproveIds {
  applicantId: number;
  taskId: string;
}

export const resolveTaskIdsForApprove = (
  uiRow: ITasksTableRow,
  rawTask: ITaskListItem | undefined,
  taskIdMap: Record<number, string>,
): ResolvedTaskApproveIds => {
  const applicantInfo = parseTaskApplicantInfo(rawTask?.applicant_info);
  const applicantId =
    parseTaskApplicantId(applicantInfo, rawTask?.applicant_id) ||
    (uiRow.student_id > 0 ? uiRow.student_id : 0);

  const taskId = resolveTaskApiId(rawTask, taskIdMap[uiRow.task_id], uiRow.task_id);

  return { applicantId, taskId };
};
